<template>
  <div class="home-page">

    <div v-if="showhome !== ''">
      <!-- <button @click="uploadstatus= 'error'">ccc</button> -->
      <new_record v-if="showhome == 'new_record'" />
      <radiopage v-if="showhome == 'radio'" :uploadstatus="uploadstatus" :uploadProgress="uploadProgress"
        @upload_audio="uploadr2_audio" @openvipchaoxian="openvipchaoxian">
      </radiopage>
      <relradiopage v-if="showhome == 'realradio'" :uploadstatus="uploadstatus" @chooeselanguage="chooeselanguage"
        @chooeselanguagein="chooeselanguagein" @backhomepage="backhomepage" @upload_audio="update_audio_notes"
        @openvipchaoxian="openvipchaoxian"></relradiopage>
      <folder-page v-if="showhome == 'folder'" :folder="currentFolder" :folders="folders" @backhomepage="backhomepage"
        @opennotes="opennotes" @addNotes="showAddNotesToFolder" @folderUpdated="handleFolderUpdated"
        @showCreateFolder="showCreateFolder" />
    </div>
    <div v-else>
      <section class="new-note">
        <div class="line1">
          <div class="h2box">What would you like to explore today?</div>
          <div class="line2" v-if="false"></div>
          <div class="h2box" v-if="false">
            <div class="btn" @click="opennewpage('deepresearch')">DeepResearch</div>
          </div>
          <div class="line2" v-if="false"></div>
          <div class="h2box" v-if="false" @click="opennewpage('unstuck')">
            <div class="btn">Unstuck</div>
          </div>
          <div class="line2" v-if="false"></div>
          <div class="h2box" v-if="false">
            <div class="btn" @click="opennewpage('askanything')">Ask Anything</div>
          </div>
          <p v-if="false" @click="copyemail()">Feedback: easynote_ai@hotmail.com</p>
        </div>
        <!-- <p>Select your input</p> -->
        <div class="note-options">

          <div class="caozuo" @click="directToRecordingPage('record')">
            <img :src="record_img" alt="" />
            <div class="textp">
              <h3>Record Live Lecture</h3>
              <span>Real time transcript</span>
            </div>
            <div class="new_jiaobiao">
              New
            </div>
          </div>
          <div class="caozuo" @click="directToRecordingPage('audio')">
            <img :src="audio_img" alt="" />
            <div class="textp">
              <h3>Record / Upload Audio</h3>
              <span>For better note accuracy</span>
            </div>
          </div>
          <div class="caozuo" @click="chooesSub('video')">
            <img :src="youtube_img" alt="" />
            <div class="textp">
              <h3>YouTube / Bilibili Video</h3>
              <span>Paste a YouTube or Bilibili link</span>
            </div>
          </div>
          <div class="caozuo" @click="chooesSub('upload')">
            <img :src="upload_img" alt="" />
            <div class="textp">
              <h3>Document Upload</h3>
              <span> PDF / PPT / DOC / TXT</span>
            </div>
          </div>
        </div>
      </section>
      <section class="my-notes">
        <div class="titlebox">
          <h3 class="mynote">My notes</h3>

          <div class="pagination">
            <button class="create-folder-btn" @click="showCreateFolder">
              <i class="el-icon-folder-add"></i>
              Create Folder
            </button>
            <div class="search-container">
              <input class="input_search" type="text" @input="changesearchnotes" @keyup.enter="searchnotes"
                v-model="searchQuery" placeholder="Search your history notes." />
              <el-button class="btn_search" @click="searchnotes" :disabled="issearchnotes"
                element-loading-spinner="el-icon-loading" icon="el-icon-search" circle></el-button>
            </div>
          </div>
        </div>

        <!-- 文件夹骨架屏 -->
        <div v-if="isLoadingFolders" class="folder-skeleton-container">
          <div class="skeleton-folder-item" v-for="i in 4" :key="'folder-skeleton-' + i">
            <div class="skeleton-folder-icon"></div>
            <div class="skeleton-folder-info">
              <div class="skeleton-folder-title"></div>
            </div>
            <div class="skeleton-folder-action"></div>
          </div>
        </div>

        <div class="folder-list" v-if="!isLoadingFolders && folders.length > 0">
          <div class="folder-item" @click="openFolder(folder)" v-for="folder in folders" :key="folder.folder_id">
            <div class="folder-icon">
              <img :src="folderimg" alt="" />
            </div>
            <div class="folder-info">
              <h4>{{ folder.folder_name }}</h4>
              <div class="folder-meta">
                <div class="note-count">
                  <span class="count-number">{{ folder.note_count }}</span>
                  <span class="count-label">{{ folder.note_count < 2 ? 'Note' : 'Notes' }}</span>
                </div>
              </div>
            </div>
            <div class="folder-actions">
              <el-dropdown trigger="click" @command="handleFolderCommand($event, folder)" @click.stop>
                <i class="el-icon-more" @click.stop></i>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="rename">
                    <i class="el-icon-edit folder-dropdown-icon"></i>
                    Rename
                  </el-dropdown-item>
                  <el-dropdown-item command="delete" class="danger-item" style="color: #ff0000;">
                    <i class="el-icon-delete folder-dropdown-icon" style="color: #ff0000;"></i>
                    Delete
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </div>
        </div>

        <!-- 笔记骨架屏 -->
        <div v-if="isloading" class="skeleton-container">
          <div class="skeleton-note" v-for="i in 5" :key="'skeleton-' + i">
            <div class="skeleton-badge"></div>
            <div class="skeleton-icon"></div>
            <div class="skeleton-content">
              <div class="skeleton-title"></div>
              <div class="skeleton-text"></div>
            </div>
            <div class="skeleton-action"></div>
          </div>
        </div>

        <div class="note" @click="opennotes(note, '')" v-show="!isloading" v-for="(note, i) in sortedNotes" :key="i">
          <!-- <div class="badge">{{ getCodeByName(note.language) }}</div> -->
          <span class="note-icon">
            <!-- <i class="el-icon-s-claim"></i> -->
            <img v-if="note.filetype == 'record'" :src="darkrecord_img" alt="" />
            <img v-if="note.filetype == 'audio'" :src="darkaudio_img" alt="" />
            <img v-if="note.filetype == 'youtube'" :src="darkyoutube_img" alt="" />
            <img v-if="note.filetype == 'pdf'" :src="darkupload_img" alt="" />
          </span>
          <div class="content">
            <h3 :class="{ redcolor: note.status === 3 }">
              {{ note.notename }}
            </h3>
            <p>Created on {{ formatDateTime(note.createtime) }}</p>
          </div>
          <span class="errorinfo" v-if="note.status === 3">Failed</span>
          <div class="note-actions" @click.stop>
            <el-dropdown trigger="click" @command="handleNoteCommand($event, note)">
              <i class="el-icon-more note-more-icon"></i>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="edit">
                  <i class="el-icon-edit note-dropdown-icon"></i>
                  Rename
                </el-dropdown-item>
                <el-dropdown-item command="move">
                  <i class="el-icon-folder note-dropdown-icon"></i>
                  Move to Folder
                </el-dropdown-item>
                <el-dropdown-item command="delete" class="danger-item">
                  <i class="el-icon-delete note-dropdown-icon"></i>
                  Delete
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </div>
        <div class="fenyebox" v-show="allnotecount > pageSize">
          <el-pagination class="fenyecaozuo" @size-change="handleSizeChange" @current-change="handleCurrentChange"
            :current-page.sync="currentPage" :page-size="pageSize" layout="prev, pager, next" :total="allnotecount">
          </el-pagination>
        </div>

        <div class="error-message" v-show="notestats == 0">
          <img class="error-icon" :src="welcomeimg" />
          <p>Welcome! Click any option above to start creating your first note.</p>
        </div>
        <div class="error-message" v-show="notestats == 1">
          <img class="error-icon" :src="nonepdficon" />
          <p>Sorry, we couldn't find this pdf file. Please try again later.</p>
        </div>
      </section>
    </div>

    <popupupgrade v-if="isupgrade" :upgradedata="upgradedata" />
    <popupchaoxian ref="vipchaoxian" :textcontent="vipchaoxiantext" />
    <popupchaoxian ref="uploadchaoxian" :textcontent="uploadchaoxiantext" />
    <popupchaoxian ref="recordchaoxian" :textcontent="vip_livechaoxian" />
    <popupAudio ref="pAudio" @chooeselanguage="chooeselanguage" @chooeselanguagein="chooeselanguagein"
      @setrecordtitle="setrecordtitle" @home_chooseaside="home_chooseaside" @upload_audio="uploadr2_audio"
      :uploadProgress="uploadProgress" :taskisloading="taskisloading" />
    <popupVideo ref="pVideo" @chooeselanguage="chooeselanguage" @createnotevideo="createnotevideo"
      :uploadProgress="uploadProgress" :taskisloading="taskisloading" />
    <popupUpload @chooeselanguage="chooeselanguage" @upload_file="uploadr2_audio" ref="pUpload"
      :uploadProgress="uploadProgress" :taskisloading_u="taskisloading_u" />
    <popup-create-folder ref="createFolderDialog" @folderCreated="handleFolderCreated" />
    <popup-folder-edit-name ref="folderSettings" :folder="currentFolder" @folderUpdated="handleFolderUpdated"
      @folderDeleted="handleFolderDeleted" />
    <popup-note-settings ref="noteSettings" :note="currentNote" :folders="folders" @noteUpdated="handleNoteUpdated"
      @showCreateFolder="showCreateFolder" @deletenote="handleDeleteNote" />
    <popup-extra ref="extraPopup" />
    <popup-delete-confirm ref="deleteConfirm" :folder="currentFolder" @confirm="handleFolderDeleted" />
    <popup-note-delete-confirm ref="noteDeleteConfirm" :note="currentNote" @confirm="handleDeleteNote" />
    <popup-note-rename ref="noteRename" :note="currentNote" @noteRenamed="handleNoteRenamed" />
    <popup-note-move ref="noteMove" :note="currentNote" :folders="folders" @noteMoved="handleNoteMoved"
      @showCreateFolder="showCreateFolder" />
    <popup-failed-note ref="failedNotePopup" :note="currentNote" @deleted="handleDeleteNote" />
  </div>
</template>
<script>
import new_record from "@/views/pages/home_page/new_record.vue";
import radiopage from "@/views/pages/home_page/radio_page.vue";
import relradiopage from "@/views/pages/home_page/real_radio_page.vue";
import popupAudio from "@/views/pages/home_page/popups/popup_audio.vue";
import popupVideo from "@/views/pages/home_page/popups/popup_video.vue";
import popupUpload from "@/views/pages/home_page/popups/popup_upload.vue";
// import popupsubject from "@/views/pages/home_page/popups/popup_subjects.vue";
import popupupgrade from "@/views/pages/home_page/popups/popup_upgrade.vue";
import popupchaoxian from "@/views/pages/home_page/popups/popup_chaoxian.vue";
// import popupRecord from "@/views/pages/home_page/popups/popup_record_tool.vue"; 
import PopupCreateFolder from "./popups/popup_create_folder.vue";
import PopupFolderEditName from "./popups/popup_folder_editname.vue";
import PopupNoteSettings from './popups/popup_note_settings.vue'
import FolderPage from './folder_page.vue'
import PopupExtra from './popups/popup_extra.vue'
import PopupDeleteConfirm from './popups/popup_delete_confirm.vue'
import PopupNoteDeleteConfirm from './popups/popup_note_delete_confirm.vue'
import PopupNoteRename from './popups/popup_note_rename.vue'
import PopupNoteMove from './popups/popup_note_move.vue'
import PopupFailedNote from './popups/popup_failed_note.vue'

export default {
  name: "HomePage",
  components: {
    new_record,
    radiopage,
    relradiopage,
    popupAudio,
    popupVideo,
    popupUpload,
    // popupsubject,
    popupupgrade,
    popupchaoxian,
    PopupCreateFolder,
    PopupFolderEditName,
    PopupNoteSettings,
    FolderPage,
    PopupExtra,
    PopupDeleteConfirm,
    PopupNoteDeleteConfirm,
    PopupNoteRename,
    PopupNoteMove,
    PopupFailedNote
  },
  props: {
    showhome_home: {
      type: Object,
    }
  },
  watch: {
    showhome_home(newVal) {
      if (newVal.showhome_home == 'home') {
        this.showhome = "";
      }
    }
  },
  data() {
    return {
      // realradio   radio  new_record
      showhome: "",
      folderimg: require("@/assets/images/homepage/folder_new.png"),
      darkrecord_img: require("@/assets/images/index/icons/dark/10.png"),
      darkaudio_img: require("@/assets/images/index/icons/dark/1.png"),
      darkyoutube_img: require("@/assets/images/index/icons/dark/2.png"),
      darkupload_img: require("@/assets/images/index/icons/dark/3.png"),
      record_img: require("@/assets/images/index/icons/10.png"),
      audio_img: require("@/assets/images/index/icons/1.png"),
      youtube_img: require("@/assets/images/index/icons/2.png"),
      upload_img: require("@/assets/images/index/icons/3.png"),


      nonepdficon: require("@/assets/images/home/none_pdf_icon.png"),
      welcomeimg: require("@/assets/images/home/welcome.png"),
      loadingimg: require("@/assets/images/noteindex/loading_img1.gif"),
      showpopupsubject: false,
      mynotes: [],
      chooseclass: "other",
      chooesmodel: "",
      currentPage: 1,
      pageSize: 10,
      allnotecount: 0,
      hideonsinglepage: true,
      issearchnotes: false,
      languages: [
        { code: "ZH", name: "Chinese" },
        { code: "ZH(T)", name: "Traditional Chinese (Hong Kong)" },
        { code: "EN", name: "English" },
        { code: "ES", name: "Spanish" },
        { code: "FR", name: "French" },
        { code: "DE", name: "German" },
        { code: "IT", name: "Italian" },
        { code: "JA", name: "Japanese" },
        { code: "RU", name: "Russian" },
        { code: "AR", name: "Arabic" },
        { code: "HI", name: "Hindi" },
        { code: "PT", name: "Portuguese" },
        { code: "NL", name: "Dutch" },
        { code: "KO", name: "Korean" },
        { code: "TR", name: "Turkish" },
      ],
      uploadchaoxiantext: "You have submitted too many tasks. Please try again later.",
      vipchaoxiantext: "Your free trial is almost over. <br> Please save your recordings before upgrade to premium to avoid losing them.",
      vip_livechaoxian: "You've used up your limit for this month. <br>If you need to continue using this service, please contact <span>easynote_ai@hotmail.com</span>",

      language: "",
      languagename: "",
      languagein: "",
      languagenamein: "",

      recordtitle: "",
      searchQuery: "",

      isloading: false,
      taskisloading: false,
      taskisloading_u: false,

      selectedFile: null,
      chunkSize: 1024 * 1024, // 1MB
      uploadProgress: 0,
      uploadstatus: '',


      isupgrade: false,
      upgradedata: {
        version: "1.0.1",
        date: "2024-09-07 14:47:55",
        features: [
          "Supports URL sharing.",
        ]
      },

      folders: [], // 文件夹列表
      isLoadingFolders: false, // 加载状态

      recordtool: '',

      upload_audio_params: null,
      currentFolder: null,

      currentNote: null,

    };
  },
  mounted() {
    this.getupgrade();
    if (
      this.$route.params &&
      this.$route.params.dontgetmynotes == "backhomepage" &&
      this.mynotes.length > 0
    ) {
      console.log("dontgetmynotes");
    } else {
      this.getmynotes();
    }
    this.getminfo();
    this.getFolders(); // 添加获取文件夹的调用
    this.$cookies.set('ischilddeep', '')
  },
  computed: {

    filteredFiles() {
      // return this.mynotes.filter(file =>
      //   file.notename.toLowerCase().includes(this.searchQuery.toLowerCase())
      // );
      return this.mynotes;
    },
    sortedNotes() {
      // return [...this.filteredFiles].sort((a, b) => {
      //   return new Date(b.createtime) - new Date(a.createtime);
      // });
      return this.mynotes;
    },
    notestats() {
      if (this.isloading) return 2;
      if (this.mynotes.length == 0) return 0;
      if (this.sortedNotes.length == 0) return 1;

      return 3;
    },
  },
  methods: {
    ceshi() {
      this.$refs.uploadchaoxian.openModal();
    },

    setrecordtitle(title) {
      this.recordtitle = title;
    },
    opennewpage(path) {
      // 新开标签页
      window.open('/' + path, '_blank');
    },
    async update_audio_notes(filetype, filename, fileKey, elapsedTime, transcript = '', noteid = -1) {
      try {
        const subid = this.$cookies.get("subid");
        const response = await this.$axios.post("/api/update_audio_notes/", {
          filename: filename,
          filetype: filetype,
          filekey: fileKey,
          subject: this.chooseclass,
          languagein: this.languagein,
          language: this.languagename,
          subid: subid,
          elapsedTime: elapsedTime,
          comefrom: 'web',
          chooesmodel: this.chooesmodel,
          transcript: transcript,
          noteid: noteid
        });

        const resdata = response.data;
        if (resdata.code == 200) {
          this.handleSuccess(resdata);
        } else {
          this.$message({
            message: resdata.messages || 'Failed to update notes',
            type: 'error',
          });
        }
      } catch (error) {
        console.error('Error occurred while updating notes:', error);
        this.$message({
          message: error.response?.data?.messages || 'An error occurred while updating notes, please try again later',
          type: 'error',
          duration: 5000
        });

        // Additional error handling logic if needed
        if (error.response?.status === 401) {
          // Handle unauthorized error
          this.$router.push('/login');
        } else if (error.code === 'ECONNABORTED') {
          // Handle request timeout
          this.$message.error('Request timed out, please check your network connection');
        }
      }
    },
    async getminfo() {
      try {
        const subid = this.$cookies.get("subid");
        const response = await this.$axios.post("/api/getminfo/", {
          subid: subid,
        });
        const resdata = response.data;
        if (resdata.code == 200) {
          // console.log(resdata);
          this.$cookies.set("m_tkn", resdata.mtype, { expires: 10 });
        }
      } catch (error) {
        console.error("Error:", error);
      }
    },
    async uploadToR2(file) {
      try {
        const subid = this.$cookies.get('subid');
        // 1. 获取预签名URL
        const { data } = await this.$axios.post('/api/get_upload_url/', {
          fileName: file.name,
          fileType: file.type,
          subid: subid
        });

        if (!data.uploadUrl) {
          throw new Error('Failed to get upload URL');
        }

        // 2. 使用 XMLHttpRequest 上传文件以获取进度
        return new Promise((resolve, reject) => {
          const xhr = new XMLHttpRequest();

          // 监听上传进度
          xhr.upload.onprogress = (event) => {
            if (event.lengthComputable) {
              const percentComplete = Math.max(2, Math.floor((event.loaded / event.total) * 100));
              console.log(`Upload progress: ${percentComplete}%`);

              // 更新上传进度
              if (percentComplete < 99) {
                this.uploadProgress = percentComplete;
              }
            }
          };

          // 上传完成
          xhr.onload = () => {
            if (xhr.status === 200) {
              resolve({
                success: true,
                fileKey: data.fileKey,
                url: data.uploadUrl.split('?')[0]
              });
            } else {
              reject(new Error(`Upload failed with status: ${xhr.status}`));
            }
          };

          // 上传错误
          xhr.onerror = () => {
            reject(new Error('Network error during upload'));
          };

          // 开始上传
          xhr.open('PUT', data.uploadUrl, true);
          xhr.setRequestHeader('Content-Type', file.type);
          xhr.send(file);
        });

      } catch (error) {
        console.error('Upload failed:', error);
        this.$message.error(`Upload failed: ${error.message}`);
        throw error;
      }
    },
    async uploadr2_audio(justment, file, name, elapsedTime) {
      this.uploadstatus = 'uploading';
      this.uploadProgress = 0;

      if (!file) return;

      // 检查网络连接状态
      if (!navigator.onLine) {
        this.uploadstatus = 'error';
        this.$message.error('No internet connection. Your recording has been saved locally.');
        return;
      }
      try {
        const uploadResult = await this.uploadToR2(file);
        if (!uploadResult.success) {
          throw new Error('Upload failed');
        }
        this.uploadProgress = 100;
        const filekey = uploadResult.fileKey;

        let filename = name;
        if (this.recordtitle != '') {
          // 如果recordtitle不为空，则将recordtitle作为文件名，并使用name的后缀
          filename = this.recordtitle + '.' + name.split('.').pop();
        }

        try {
          const subid = this.$cookies.get("subid");
          const response = await this.$axios.post("/api/update_audio_notes/", {
            filename: filename,
            filetype: justment,
            filekey: filekey,
            subject: this.chooseclass,
            languagein: this.languagein,
            language: this.languagename,
            subid: subid,
            elapsedTime: elapsedTime,
            comefrom: 'web',
            chooesmodel: this.chooesmodel,
          });

          const resdata = response.data;
          if (resdata.code == 200) {
            this.$message({
              message: resdata.messages,
              type: 'success',
            });
            this.handleSuccess(resdata);
          } else {
            this.$message({
              message: resdata.messages || 'Failed to update notes',
              type: 'error',
            });
          }
        } catch (error) {
          console.error('Error occurred while updating notes:', error);
          this.$message({
            message: error.response?.data?.messages || 'An error occurred while updating notes, please try again later',
            type: 'error',
            duration: 5000
          });

          // Additional error handling logic if needed
          if (error.response?.status === 401) {
            // Handle unauthorized error
            this.$router.push('/login');
          } else if (error.code === 'ECONNABORTED') {
            // Handle request timeout
            this.$message.error('Request timed out, please check your network connection');
          }
        }

      } catch (error) {
        console.error('Upload error:', error);
        this.uploadstatus = 'error';
        this.$message.error('Upload failed. Your recording has been saved locally.');
        return;
      }
    },
    copyemail() {
      const emailfeed = "easynote_ai@hotmail.com";
      const input = document.createElement("input");
      input.value = emailfeed;

      // 将 input 元素添加到文档中
      document.body.appendChild(input);

      // 选中 input 中的内容
      input.select();

      // 执行复制命令
      document.execCommand("copy");

      // 移除临时的 input 元素
      document.body.removeChild(input);

      // 提示用户复制成功
      this.$message({
        message: "Mailbox copied to clipboard",
        type: "success",
      });
    },
    chooeselanguage(language, languagename) {
      this.language = language;
      this.languagename = languagename;
      // console.log(this.language, this.languagename, "homepage");
    },
    chooeselanguagein(language, languagename) {
      this.languagein = language;
      this.languagenamein = languagename;
      // console.log(this.languagein, this.languagenamein, "homepage_in");
    },
    async getmynotes() {
      this.isloading = true;
      this.issearchnotes = true;
      //获用户笔记
      try {
        const subid = this.$cookies.get("subid");
        const response = await this.$axios.post("/api/getmynotes/", {
          subid: subid,
          currentpage: this.currentPage,
          pagesize: this.pageSize,
          searchtext: this.searchQuery,
          searchtype: 'folder',
        });
        const resdata = response.data;
        this.isloading = false;
        this.issearchnotes = false;
        if (resdata.code == 200) {
          this.mynotes = resdata.mynotes;
          this.allnotecount = resdata.total;
        }
      } catch (error) {
        console.error("Error:", error);
      }
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getmynotes();
    },
    searchnotes() {
      this.currentPage = 1;
      this.getmynotes();
    },
    changesearchnotes() {
      if (this.searchQuery == '') {
        this.currentPage = 1;
        this.getmynotes();
      }
    },
    backhomepage() {
      this.showhome = "";
      this.getmynotes();
      this.getFolders();
    },
    selectclass(item) {
      this.chooseclass = item.title;
      // 创建一个映射对象，用于根据chooesmodel的值找到对应的组件引用
      const modalRefs = {
        audio: this.$refs.pUpload,
        video: this.$refs.pVideo,
        upload: this.$refs.pUpload,
      };
      // 使用chooesmodel的值从映射对象中查找对应的组件引用，并调用其openModal方法
      // console.log(item, this.chooesmodel, modalRefs[this.chooesmodel]);
      if (modalRefs[this.chooesmodel]) {
        modalRefs[this.chooesmodel].openModal();
      }
    },
    async chooesSub(model) {
      const subid = this.$cookies.get("subid");
      const uploadisok = await this.$axios.post('/api/uploadisok/', {
        subid: subid,
        model: model,
      });
      const resdata = uploadisok.data;
      if (resdata.code != 200) {
        if (resdata.code == 303 && resdata.mtype > 0) {
          this.$refs.extraPopup.openModal('over');
          return;
        } else if (resdata.code == 1303) {
          const dontShowAgain = this.$cookies.get('dontShowAgain', false);
          if (dontShowAgain != 'true') {
            this.$refs.extraPopup.openModal('running');
            return;
          }
        } else if (resdata.code == 301) {
          this.$message({
            type: "error",
            message: resdata.messages,
          });
          return;
        } else {
          this.$message({
            type: "error",
            message: resdata.messages,
          });
          this.gopaypage();
          return;
        }
      }

      this.chooesmodel = model;
      this.taskisloading = false;

      // 直接打开对应的弹窗，不再显示学科选择弹窗
      if (model === 'video') {
        this.$refs.pVideo.openModal();
      } else if (model === 'upload') {
        this.$refs.pUpload.openModal();
      }
    },
    opennotes(note, mode = '') {
      // 先从服务器获取最新的task_count
      this.$axios.post("/api/get_note_task_count/", {
        noteid: note.noteid
      }).then(response => {
        if (response.data.code === 200) {
          // 更新笔记的task_count
          note.task_count = response.data.task_count;

          // 只有当任务数量大于1且状态为3时才显示失败弹窗
          if (note.status === 3 && note.task_count > 1) {
            this.currentNote = note;
            this.$nextTick(() => {
              this.$refs.failedNotePopup.openModal();
            });
          } else {
            // 其他所有情况都打开笔记页面
            this.$router.push({
              name: "newnotesPage",
              params: { note: note, mode: mode },
            });
          }
        } else {
          console.error("获取任务数量失败:", response.data.messages);
          // 获取失败时，使用原有逻辑
          if (note.status === 3) {
            this.currentNote = note;
            this.$nextTick(() => {
              this.$refs.failedNotePopup.openModal();
            });
          } else {
            this.$router.push({
              name: "newnotesPage",
              params: { note: note, mode: mode },
            });
          }
        }
      }).catch(error => {
        console.error("请求任务数量出错:", error);
        // 出错时使用原有逻辑
        if (note.status === 3) {
          this.currentNote = note;
          this.$nextTick(() => {
            this.$refs.failedNotePopup.openModal();
          });
        } else {
          this.$router.push({
            name: "newnotesPage",
            params: { note: note, mode: mode },
          });
        }
      });
    },
    home_chooseaside(key) {
      // console.log("home_chooseaside", key);
      this.showhome = key;
    },
    async createnotevideo(linksrc) {
      try {
        const subid = this.$cookies.get("subid");
        const response = await this.$axios.post("/api/createnotevideo/", {
          linksrc: linksrc,
          subject: this.chooseclass,
          subid: subid,
          language: this.languagename,
        });
        this.handleSuccess(response.data);
      } catch (error) {
        this.$message.error("Note creation failed.");
        console.error("Error:", error);
      }
    },
    gopaypage() {
      // this.$router.push({
      //   name: "IndexPage", // 目标路由的名称
      //   params: { pagekey: "price" }, // 通过 params 传递参数
      //   // query: { category: "electronics" }, // 通过 query 传递参数
      // });
      this.$emit('gopaypage');
    },
    handleSuccess(response) {
      if (response.code == 401) {
        this.$message.error(response.messages);
        this.taskisloading = false;
        this.taskisloading_u = false;
        return;
      }
      if (response.code == 203) {
        this.$message.error(response.messages);
        this.uploadstatus = 'error';
        return;
      }
      if (response.code == 201) {
        this.taskisloading = false;
        this.taskisloading_u = false;
        this.$message.error(response.messages);
        this.uploadstatus = 'error';
        return;
      }
      if (response.code == 205) {
        this.taskisloading = false;
        this.taskisloading_u = false;
        this.uploadstatus = 'error';
        this.$refs.uploadchaoxian.openModal();
        return;
      }
      if (response.code == 303) {
        this.$message({
          message: response.messages,
          type: 'error',
          duration: 6000 // 5000 毫秒（5秒）
        });
        this.$refs.vipchaoxian.openModal();
        return;
      }

      const noteid = response.noteid;
      const askid = response.askid;
      if (!noteid) {
        this.$message({
          message: "Note creation failed. Please save the recording file in time!",
          type: 'error',
          duration: 6000 // 5000 毫秒（5秒）
        });
        this.uploadstatus = 'error';
        return;
      }

      this.$message.success("File uploaded successfully!");
      // 上传成功
      // 关闭弹窗
      if (this.$refs.pAudio) {
        this.$refs.pAudio.closeModal();
      }
      if (this.$refs.pVideo) {
        this.$refs.pVideo.closeModal();
      }
      if (this.$refs.pUpload) {
        this.$refs.pUpload.closeModal();
      }
      this.showhome = "";
      // 更新笔记列表
      // const resnote = { title: "测试笔记名称", date: "Jul 9, 2024" };
      // this.mynotes.push(resnote);
      console.log("Response:", response);
      try {
        this.$router.push({
          name: "newnotesPage",
          params: {
            noteid: noteid,
            askid: askid,
            status: 10
          },
        }).catch(err => {
          console.error("Router error:", err);
          // 备用跳转方案
          this.$router.push({
            path: '/notes',
            query: {
              noteid: noteid,
              status: 10
            }
          });
        });
      } catch (err) {
        console.error("Navigation failed:", err);
        this.$message.error("页面跳转失败,请重试");
      }
    },
    handleError(error) {
      alert("File upload failed.");
      this.uploadstatus = 'error';
      console.error("Error:", error);
    },
    getCodeByName(name) {
      const language = this.languages.find((lang) => lang.name === name);
      return language ? language.code : "EN";
    },
    formatDateTime_folder(dateTime) {
      const date = new Date(dateTime);
      const options = {
        weekday: "long", // 添加星期几
        year: "numeric",
        month: "long",
        day: "numeric",
      };
      return date.toLocaleString("en-US", options);
    },
    formatDateTime(dateTime) {
      const date = new Date(dateTime);
      const options = {
        weekday: "long", // 添加星期几
        year: "numeric",
        month: "long",
        day: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: true,
      };
      return date.toLocaleString("en-US", options);
    },
    openvipchaoxian() {
      this.$refs.vipchaoxian.openModal();
    },
    async getupgrade() {
      try {
        const response = await this.$axios.post("/api/getupgrade/", {});
        const resdata = response.data;
        if (resdata.code == 200) {
          const getupgrade = resdata.data;
          const nowwversion = localStorage.getItem("version");
          if (getupgrade.version != nowwversion) {
            localStorage.setItem("version", getupgrade.version);
            this.upgradedata = getupgrade;
            this.isupgrade = true;
          }
        }
      } catch (error) {
        console.error("Error:", error);
      }
    },
    showCreateFolder() {
      this.$refs.createFolderDialog.openModal();
    },
    handleFolderCreated(folderData) {
      // 更新文件夹列表
      // console.log(folderData, "folderData");
      this.folders = folderData;
    },
    async openFolder(folder) {
      this.currentFolder = folder
      this.showhome = 'folder'
      // 记录当前状态，用于返回
      this.$cookies.set('ischilddeep', 'folder')
    },
    async getFolders() {
      try {
        this.isLoadingFolders = true; // 开始加载时设置为true
        const subid = this.$cookies.get("subid");
        const response = await this.$axios.post("/api/getfolders/", {
          subid: subid
        });

        if (response.data.code === 200) {
          this.folders = response.data.data.folders;
        } else {
          this.$message({
            message: response.data.messages || 'Failed to get folders',
            type: 'error'
          });
        }
      } catch (error) {
        console.error('Error getting folders:', error);
        this.$message({
          message: error.response?.data?.messages || 'An error occurred while getting folders',
          type: 'error',
          duration: 5000
        });
      } finally {
        // 无论成功还是失败，最终都设置为false
        setTimeout(() => {
          this.isLoadingFolders = false;
        }, 500); // 添加短暂延迟，确保骨架屏有足够时间显示
      }
    },
    openFolderSettings(folder) {
      if (!folder) return
      this.currentFolder = { ...folder }
      this.$nextTick(() => {
        this.$refs.folderSettings.openModal()
      })
    },
    handleFolderUpdated(folder) {
      this.folders = this.folders.map(f => f.folder_id === folder.folder_id ? folder : f);

      if (!folder.folder_name.trim()) {
        this.folderName = folder.folder_name
        return
      }
      try {
        this.$axios.post('/api/renamefolder/', {
          folder_id: folder.folder_id,
          folder_name: folder.folder_name,
          subid: this.$cookies.get('subid')
        })
      } catch (error) {
        this.$message.error(error.response?.data?.messages || 'Failed to update folder name')
      }

    },
    handleFolderDeleted(folder) {
      this.folders = this.folders.filter(f => f.folder_id !== folder.folder_id);
      this.getmynotes();
    },
    openNoteSettings(note) {
      this.currentNote = note;
      this.$nextTick(() => {
        this.$refs.noteSettings.openModal()
      })
    },
    handleNoteUpdated({ note, folder, action }) {
      if (action === 'move') {
        if (!note.folder_id) {
          // 如果笔记被移出文件夹，添加到主页列表
          this.mynotes.unshift(note)
        } else {
          // 如果笔记被移入文件夹，从主页列表移除
          this.mynotes = this.mynotes.filter(n => n.noteid !== note.noteid)
        }
        // 更新文件夹列表
        if (folder) {
          const folderIndex = this.folders.findIndex(f => f.folder_id === folder.folder_id)
          if (folderIndex !== -1) {
            this.$set(this.folders, folderIndex, folder)
          }
          this.getFolders()
        }
        // 关闭设置弹窗
        this.$refs.noteSettings.closeModal()
      } else if (action === 'rename') {
        // 更新笔记标题
        this.mynotes = this.mynotes.map(n =>
          n.noteid === note.noteid ? { ...n, notename: note.notename } : n
        )

        if (!note.notename.trim()) {
          // this.$message.error('Note title cannot be empty')
          this.noteTitle = note.notename
          return
        }

        try {

          this.$axios.post('/api/updatenotename/', {
            noteid: note.noteid,
            notename: note.notename.trim(),
          })

        } catch (error) {
          console.error('更新笔记标题失败:', error)
        }
      }


    },
    handleDeleteNote() {
      this.getmynotes();
    },
    showAddNotesToFolder() {
      // 这里可以实现添加笔记到文件夹的功能
      // 可以打开一个选择笔记的弹窗
      console.log('Add notes to folder')
    },
    directToRecordingPage(type) {
      // 检查用户是否可以使用该功能
      this.checkRecordingPermission(type).then(canRecord => {
        if (canRecord) {
          this.chooesmodel = type;
          if (type === 'record') {
            this.recordtool = 'title';
            // 直接打开录音页面
            this.home_chooseaside('realradio');
          } else if (type === 'audio') {
            // 直接打开录音页面
            // this.home_chooseaside('radio');
            // 打开弹窗
            this.$refs.pAudio.openModal();
          }
        }
      });
    },
    async checkRecordingPermission(type) {
      const subid = this.$cookies.get("subid");
      try {
        const uploadisok = await this.$axios.post('/api/uploadisok/', {
          subid: subid,
          model: type,
        });
        const resdata = uploadisok.data;
        if (resdata.code != 200) {
          if (resdata.code == 303 && resdata.mtype > 0) {
            this.$refs.extraPopup.openModal('over');
            return false;
          } else if (resdata.code == 1303) {
            const dontShowAgain = this.$cookies.get('dontShowAgain', false);
            if (dontShowAgain != 'true') {
              this.$refs.extraPopup.openModal('running');
              return false;
            }
          } else if (resdata.code == 301) {
            this.$message({
              type: "error",
              message: resdata.messages,
            });
            return false;
          } else {
            this.$message({
              type: "error",
              message: resdata.messages,
            });
            this.gopaypage();
            return false;
          }
        }
        return true;
      } catch (error) {
        console.error("Error checking recording permission:", error);
        this.$message({
          type: "error",
          message: "Failed to check permission. Please try again.",
        });
        return false;
      }
    },
    handleFolderCommand(command, folder) {
      if (command === 'rename') {
        this.openFolderSettings(folder);
      } else if (command === 'delete') {
        this.currentFolder = folder;
        this.$nextTick(() => {
          this.$refs.deleteConfirm.openModal();
        });
      }
    },
    handleNoteCommand(command, note) {
      if (command === 'edit') {
        this.currentNote = note;
        this.$nextTick(() => {
          this.$refs.noteRename.openModal();
        });
      } else if (command === 'move') {
        this.currentNote = note;
        this.$nextTick(() => {
          this.$refs.noteMove.openModal();
        });
      } else if (command === 'delete') {
        this.currentNote = note;
        this.$nextTick(() => {
          this.$refs.noteDeleteConfirm.openModal();
        });
      }
    },
    handleNoteRenamed({ note }) {
      // 更新笔记标题
      this.mynotes = this.mynotes.map(n =>
        n.noteid === note.noteid ? { ...n, notename: note.notename } : n
      )
    },
    handleNoteMoved({ note, folder }) {
      if (!note.folder_id) {
        // 如果笔记被移出文件夹，添加到主页列表
        this.mynotes.unshift(note)
      } else {
        // 如果笔记被移入文件夹，从主页列表移除
        this.mynotes = this.mynotes.filter(n => n.noteid !== note.noteid)
      }

      // 更新文件夹列表
      if (folder) {
        const folderIndex = this.folders.findIndex(f => f.folder_id === folder.folder_id)
        if (folderIndex !== -1) {
          this.$set(this.folders, folderIndex, folder)
        }
        this.getFolders()
      }
    },
  },
};
</script>
<style lang="less">
@import "@/assets/styles/hompage.less";

@primary-color: rgba(255, 255, 255, 0.2);
@background-color: rgba(255, 255, 255, 0.1);
@text-color: #ffffff;
@active-text-color: #ddd;

// 浅色主题变量
@light-primary: #4361ee;
@light-bg: #f7f9fc;
@light-text: #2d3748;
@light-border: #e2e8f0;
@light-hover: #f1f5f9;
@light-shadow-sm: 0 2px 8px rgba(0, 0, 0, 0.04);

// 添加一些渐变色变量和阴影变量
@gradient-blue: linear-gradient(135deg, #4361ee, #3a7bd5);
@gradient-purple: linear-gradient(135deg, #6366f1, #a855f7);
@shadow-hover: 0 10px 25px rgba(0, 0, 0, 0.08);
@shadow-light: 0 5px 15px rgba(0, 0, 0, 0.05);

.fenyebox {
  text-align: center;
  margin: 30px 0;

  .fenyecaozuo {
    padding: 4px 8px;
    border-radius: 5px;
    background-color: @background-color;
    display: inline-flex !important;

    el-pagination__total,
    .el-pagination__sizes,
    .el-pagination__jump {
      color: @text-color;
    }

    .btn-prev,
    .btn-next {
      background-color: transparent !important;
      color: @text-color !important;
    }

    .btn-prev:disabled,
    .btn-next:disabled {
      background-color: @primary-color !important;
    }

    .el-pager {
      li {
        background-color: transparent;
        color: @text-color;
        font-size: 0.7vw;

        &.active {
          background-color: @background-color;
          color: @active-text-color;
        }
      }
    }


    .el-pagination__prev,
    .el-pagination__next,
    .el-input__inner {
      background-color: transparent;
      color: @text-color;

      &:hover {
        background-color: @primary-color;
        color: @active-text-color;
      }
    }
  }
}

// 浅色主题分页样式
.light-theme {
  .fenyebox {
    .fenyecaozuo {
      background-color: transparent;
      box-shadow: @light-shadow-sm;
      border-radius: 10px;
      overflow: hidden;

      el-pagination__total,
      .el-pagination__sizes,
      .el-pagination__jump {
        color: @light-text;
      }

      .btn-prev,
      .btn-next {
        background-color: transparent !important;
        color: @light-text !important;
        border: 1px solid @light-border;
        transition: all 0.2s ease;

        &:hover {
          color: @light-primary !important;
          border-color: @light-primary;
          background-color: @light-hover !important;
        }
      }

      .btn-prev:disabled,
      .btn-next:disabled {
        background-color: @light-bg !important;
        color: #ccc !important;
        border-color: @light-border;
        opacity: 0.7;
      }

      .el-pager {
        li {
          background-color: transparent;
          color: @light-text;
          border: 1px solid @light-border;
          margin: 0 2px;
          font-weight: 500;
          transition: all 0.2s ease;

          &:hover {
            color: @light-primary;
            border-color: @light-primary;
          }

          &.active {
            background-color: @light-primary;
            color: white;
            border-color: @light-primary;
            font-weight: 600;
          }
        }
      }

      .el-pagination__prev,
      .el-pagination__next,
      .el-input__inner {
        background-color: transparent;
        color: @light-text;

        &:hover {
          background-color: @light-hover;
          color: @light-primary;
        }
      }
    }
  }
}

.pagination {
  display: flex;
  align-items: center;
  gap: 15px;

  .create-folder-btn {
    background-color: rgba(255, 255, 255, 0.1);
    border: none;
    color: #fff;
    padding: 10px 20px;
    display: flex;
    align-items: center;
    gap: 5px;
    border-radius: 20px;
    font-size: 14px;
    cursor: pointer;
    transition: all 0.2s ease;
    white-space: nowrap;
    min-width: fit-content;

    &:hover {
      background-color: rgba(255, 255, 255, 0.2);
      transform: translateY(-1px);
    }

    &:active {
      transform: translateY(0);
    }

    .el-icon-folder-add {
      margin-right: 4px;
      font-size: 16px;
    }
  }
}

.folder-list {
  margin: 20px 0;
  display: grid;
  grid-gap: 20px;
  grid-template-columns: repeat(4, 1fr);

  @media screen and (max-width: 1400px) {
    grid-template-columns: repeat(3, 1fr);
  }

  @media screen and (max-width: 1100px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media screen and (max-width: 768px) {
    grid-template-columns: 1fr;
  }
}

.folder-item {
  display: flex;
  align-items: center;
  background: #fff;
  border-radius: 16px;
  box-shadow: @shadow-light;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
  position: relative;
  overflow: hidden;
  border: 1px solid rgba(0, 0, 0, 0.03);

  &:hover {
    transform: translateY(-5px);
    box-shadow: @shadow-hover;

    .folder-icon img {
      transform: scale(1.05) rotate(-5deg);
    }

    .folder-meta .note-count {
      transform: translateY(0);
      opacity: 1;
    }

    &::after {
      opacity: 0.05;
    }
  }

  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: @gradient-blue;
    opacity: 0;
    transition: opacity 0.3s ease;
    z-index: 0;
    pointer-events: none;
  }

  .folder-icon {
    position: relative;
    margin-right: 15px;
    z-index: 1;

    img {
      width: 42px;
      height: 42px;
      transition: all 0.3s ease;
      filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.1));
    }
  }

  .folder-info {
    flex: 1;
    min-width: 0;
    z-index: 1;

    h4 {
      margin: 0;
      font-size: 16px;
      color: #2d3748;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      max-width: 180px;
      font-weight: 500;
      margin-bottom: 6px;
    }

    .folder-meta {
      display: flex;
      align-items: center;

      .note-count {
        display: flex;
        align-items: center;
        background: @gradient-purple;
        color: white;
        padding: 2px 8px;
        border-radius: 12px;
        font-size: 12px;
        transition: all 0.3s ease;
        transform: translateY(5px);
        opacity: 0.9;
        box-shadow: 0 2px 6px rgba(99, 102, 241, 0.2);

        .count-number {
          font-weight: 600;
          margin-right: 4px;
        }

        .count-label {
          font-size: 10px;
          opacity: 0.9;
        }
      }
    }
  }

  .folder-actions {
    margin-left: 10px;
    z-index: 1;

    i {
      font-size: 18px;
      color: #718096;
      padding: 8px;
      cursor: pointer;
      border-radius: 8px;
      transition: all 0.2s ease;

      &:hover {
        color: #4361ee;
        background-color: #f1f5f9;
      }
    }
  }
}

/deep/ .el-dropdown-menu__item.danger {
  color: #e53935;
}

/deep/ .el-dropdown-menu {
  padding: 8px 0;
  border-radius: 10px;
  border: none;
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.15);
}

/deep/ .el-dropdown-menu__item {
  font-size: 14px;
  padding: 10px 20px;
  display: flex;
  align-items: center;
  line-height: 1.4;

  &:hover {
    background-color: #f5f7fa;
  }
}

/deep/ .el-dropdown-menu__item.danger-item {
  color: #ff0000 !important;

  &:hover {
    background-color: #fff1f0;
  }

  i {
    color: #ff0000 !important;
  }
}

.folder-dropdown-icon {
  margin-right: 8px;
  font-size: 16px;
}

.folder-info h4 {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 200px;
  margin: 0;
}

.note {
  position: relative;
}

.note .content {
  max-width: 93%;
}

.note .content h3 {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 90%;
}

/* Global styles for dropdown menu */
.el-dropdown-menu__item.danger-item {
  color: #ff0000 !important;
}

.el-dropdown-menu__item.danger-item i {
  color: #ff0000 !important;
}

.el-dropdown-menu__item.danger-item:hover {
  background-color: #fff1f0 !important;
}

/* 添加笔记下拉菜单样式 */
.note-actions {
  position: absolute;
  right: 16px;
  top: 50%;
  transform: translateY(-50%);
}

.note-more-icon {
  font-size: 18px;
  color: #718096;
  padding: 8px;
  cursor: pointer;
  border-radius: 8px;
  transition: all 0.2s ease;
}

.note-more-icon:hover {
  color: #4361ee;
  background-color: #f1f5f9;
}

.note-dropdown-icon {
  margin-right: 8px;
  font-size: 16px;
}
</style>
